function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  id: "apple",
  d: "M19.493,15.213a6.479,6.479,0,0,1,3.091-5.451,6.682,6.682,0,0,0-5.235-2.837C15.119,6.7,13,8.237,11.865,8.237S8.991,6.957,7.141,6.992a7,7,0,0,0-5.92,3.588C-1.3,14.96.574,21.452,3.035,25.005c1.2,1.739,2.637,3.693,4.519,3.622,1.812-.072,2.5-1.172,4.69-1.172s2.809,1.174,4.727,1.138c1.951-.037,3.187-1.774,4.381-3.517A15.831,15.831,0,0,0,23.336,21a6.321,6.321,0,0,1-3.842-5.791Zm-3.6-10.641A6.308,6.308,0,0,0,17.377,0a6.412,6.412,0,0,0-4.216,2.169A6,6,0,0,0,11.641,6.6a5.309,5.309,0,0,0,4.247-2.026Z",
  transform: "translate(-0.022)"
});

function SvgIcApple(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23.314,
    height: 28.629,
    viewBox: "0 0 23.314 28.629",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcApple);
export default ForwardRef;